<template>
    <div>
        <!-- Day selector -->
        <div class="flex gap-2.5 overflow-x-auto no-scrollbar -mx-1 px-1 mb-6">
            <DayPill v-for="(group, i) in groups" :key="group.key" :group="group" :number="i + 1"
                :active="i === active" @click="active = i" />
        </div>

        <!-- Active day -->
        <Transition name="fade" mode="out-in">
            <div :key="current.key">
                <div class="flex items-baseline gap-2 mb-5">
                    <h3 class="text-header font-bold">{{ current.label }}</h3>
                    <span class="text-xs text-body/80 font-semibold">
                        · {{ current.items.length }} session<span v-if="current.items.length !== 1">s</span>
                    </span>
                </div>

                <SessionTimeline :items="current.items" :event-location="eventLocation" :event-title="eventTitle" />
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { AgendaGroup } from './agenda';
import DayPill from './DayPill.vue';
import SessionTimeline from './SessionTimeline.vue';

const props = defineProps<{
    groups: AgendaGroup[];
    eventLocation?: string | null;
    eventTitle?: string;
}>();

const active = ref(0);
watch(() => props.groups.length, () => { active.value = 0; });

const current = computed(() => props.groups[active.value] || props.groups[0] || { key: '', label: '', items: [] } as unknown as AgendaGroup);
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.18s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
